<script>
export default {
  name: 'UpgradeNotification'
}
</script>

<template>
  <b-notification
    :closable="false"
    has-icon
    icon="info-circle"
    icon-pack="fas"
    icon-size="is-small"
    size="is-small"
    class="upgrade-notification"
  >
    <slot />
  </b-notification>
</template>

<style scoped lang="scss">
@import '~@/assets/css/components';

.notification.upgrade-notification {
  margin-top: 10px;
  color: $muted;
  border-radius: $border-radius-sm;
  background: #EFF1F6;
  padding: .5rem 1rem;
  width: 100%;

  :deep(.media-left) {
    margin-right: .5rem;
  }
}
</style>
